/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-param-reassign */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useSelector, useDispatch } from 'react-redux';
import { compose } from 'redux';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Container,
  Fab,
  Grid,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles } from '@material-ui/core/styles';
import ImportModal from 'commons/components/Modal';
import MaintainersPaginator from '../../commons/components/MaintainersPaginator';
import DeleteModal from '../../commons/components/DeleteModal';
import { PRODUCTS, productsActions } from './reducer';
import { clone, truthty, falsy } from '../../utils/functions';
import styles from './styles';
import ProductForm from './components/productForm';
import saga from './saga';
import connectSaga from '../../utils/saga';
import { ReactReduxContext } from '../../config/configureStore';
import { homeActions } from '../Home/reducer';
import { selectState, actionProps } from '../../utils/reduxActions';
import TableActionMenu from '../../commons/components/TableActionMenu';
//i18n
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(styles);

function Products(props) {
  const { t } = useTranslation();
  const { objects, actions, formIsOpen, formControls, edit, invalidControls, deleteIsOpen } = props;

  const socketId = useSelector((state) => state.app?.socketId);
  const importLoader = useSelector((state) => state?.suppliers.importing);
  const importLoaderSuccess = useSelector((state) => state?.suppliers.importSuccess);
  const dispatch = useDispatch();

  const [productList, setProductList] = useState([]);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setProductList(
      Object.values(objects.products)
        .filter((item) => item.name && item.name.toLowerCase().includes(filter.toLowerCase()))
        .sort((a, b) => (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())),
    );
  }, [objects.products, filter]);

  useEffect(() => {
    actions.getStateFromApi();
  }, [actions]);

  useEffect(() => {
    if (!importLoader) {
      setIsUploading(false);
    }
    if (importLoaderSuccess) {
      setImportModalOpen(false);
      setImportModalOpen(false);
      setSelectedFile(null);
    }
  }, [importLoader, importLoaderSuccess]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  function toggleEdit() {
    handleClose();
    const item = Object.values(objects.products).find(
      (item) => item.id === Number(anchorEl.dataset.id),
    );
    actions.toggleEdit(item);
  }

  function changeControls(event) {
    if (event.autocomplete) {
      actions.changeControls({ [event.input]: event.value }, { [event.input]: false });
    } else {
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      actions.changeControls(
        { [event.currentTarget.id]: value },
        { [event.currentTarget.id]: false },
      );
    }
  }

  function submit() {
    if (falsy(formControls.name) || falsy(formControls.code)) {
      actions.setInvalidControls({
        name: falsy(formControls.name),
        code: falsy(formControls.code),
      });
    } else if (edit) {
      actions.editProduct(props.toEditId, formControls);
    } else {
      actions.createProduct(formControls);
    }
  }

  function submitDelete() {
    actions.deleteProduct(props.toDeleteId);
  }

  function onFilterChange(event) {
    setFilter(event.target.value);
  }

  // Agregar estas funciones
  const handleImportModal = () => setImportModalOpen(true);
  const handleCloseImport = () => {
    setImportModalOpen(false);
    setSelectedFile(null);
  };

  const handleFileUpload = (file) => {
    setSelectedFile(file);
  };

  const handleImport = (type) => {
    if (selectedFile && !isUploading) {
      setIsUploading(true);
      setImportModalOpen(false);
      dispatch({
        type: PRODUCTS.IMPORT_PRODUCTS,
        payload: {
          file: selectedFile,
          type,
          socketId,
        },
      });
      setSelectedFile(null);
      setIsUploading(false);
    }
  };
  const classes = useStyles();

  const getListItem = (product, openMenuHandler, closeMenuHandler, toggleEdit, toggleDelete) => (
    <ListItem key={`product-${product.id}`}>
      <ListItemAvatar>
        <Avatar className={classes.blue}>{(product.name || 'p')[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={product.name}
        secondary={product.code ? `Codigo: ${product.code}` : ''}
      />
      <ListItemSecondaryAction>
        <IconButton onClick={openMenuHandler} data-id={product.id}>
          <MoreVertIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Products')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3} className={classes.container}>
                <Grid container item xs={4}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label={t('Name')}
                    value={filter}
                    onChange={onFilterChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid container item>
          <Grid item xs={12} sm={4} md={3}>
            <TableActionMenu
              menuItems={[
                {
                  label: t('Export'),
                  listItems: [
                    {
                      label: t('Excel File'),
                      onClick: actions.exportProducts,
                      params: [Object.values(objects.products)],
                    },
                  ],
                },
                {
                  label: t('Import'),
                  listItems: [
                    {
                      label: t('Mass Upload'),
                      onClick: handleImportModal,
                      params: [],
                    },
                  ],
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardContent>
              {truthty(objects.products) ? (
                <MaintainersPaginator
                  classes={classes}
                  list={productList}
                  getListItem={getListItem}
                  openMenuHandler={handleClick}
                  closeMenuHandler={handleClose}
                  toggleEdit={toggleEdit}
                  toggleDelete={toggleDelete}
                />
              ) : (
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  <Typography variant="h6" component="h2">
                    {t('No products found')}
                  </Typography>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ProductForm
        isOpen={formIsOpen}
        toggleForm={toggleForm}
        changeControls={changeControls}
        controls={formControls}
        units={objects.units}
        edit={edit}
        submit={submit}
        invalidControls={invalidControls}
        varieties={objects.varieties}
      />
      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
        buttonId="delete-product"
      />
      <Fab color="primary" aria-label="add" className={classes.fab} onClick={toggleForm}>
        <AddIcon />
      </Fab>
      <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={toggleEdit}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          Editar
        </MenuItem>
        <MenuItem onClick={toggleDelete}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          Eliminar
        </MenuItem>
      </Menu>
      <ImportModal
        isOpen={importModalOpen}
        onClose={handleCloseImport}
        onImport={handleImport}
        onUploadFile={handleFileUpload}
        selectedFile={selectedFile}
        type="products"
        varieties={objects.varieties}
        socketId={socketId}
      />
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaProducts', saga });

const withConnect = connect(
  selectState(
    'products.invalidControls',
    'products.formControls',
    'products.deleteIsOpen',
    'products.toDeleteId',
    'products.formIsOpen',
    'products.toEditId',
    'products.edit',
    'app.objects',
  ),
  actionProps(clone(clone.OBJECT, homeActions, productsActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Products));
